module.exports = __webpack_public_path__ + "b1f27b43b81968ed7b1b81564024421e.png";